import { FC } from "react";
import { useRecoilValue } from "recoil";

import { loginFlowStepAtom, LoginFormFlow } from "@ryde/shared";

import {
  LoginForgotPasswordForm,
  LoginGenericForm,
  LoginMfaForm,
  LoginOtpForm,
  LoginSsoForm,
} from "./parts";

export const LoginPageFormFlow: FC = () => {
  const loginFlowStep = useRecoilValue(loginFlowStepAtom);

  switch (loginFlowStep) {
    case LoginFormFlow.FORGET_PASSWORD:
      return <LoginForgotPasswordForm />;
    case LoginFormFlow.SAML_SSO_STEP:
      return <LoginSsoForm />;
    case LoginFormFlow.OTP_STEP:
      return <LoginOtpForm />;
    case LoginFormFlow.MFA_STEP:
      return <LoginMfaForm />;
    case LoginFormFlow.GENERIC_STEP:
    default:
      return <LoginGenericForm />;
  }
};
